<app-tool-bar
  [title]="'Manage Organization'"
  [iconName]="'pi-building'"
  [isSearch]="true"
  [isDateFilter]="true"
  [isAdd]="true"
  [searchFilters]="searchFilters" 
  (handleAdd)="openAddModal()" 
  (search)="handleSearch($event)"
  (dateFilter)="handleDateFilter($event)"
  (resetDateFilter)="handleResetDateFilter()">
</app-tool-bar>

<p-dialog header="Add Organization" [(visible)]="showAddModal" [modal]="true" [style]="{width: '40rem'}" >
  <div class="flex items-center justify-center dialog-header">
    {{ editMode ? 'Edit' : 'Add' }} Organization
    <div class="absolute right-2 top-2">
      <button class="outline-none p-2" (click)="closeAddModal()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <form [formGroup]="organizationForm">
    <div class="dialog-content"> 
      <div class="grid grid-cols-2 gap-4">

        <!-- Loop through all form fields -->
        <div *ngFor="let field of [
          'name', 'type', 'address', 'city', 'state', 'country',
          'postal_code', 'contact_number', 'email', 'website',
          'establishment_year', 'registration_number', 'accreditation',
          'logo_url', 'second_logo_url', 'institution_code', 'bot_client_id'
        ]">
          <label class="block text-sm font-medium mb-1 capitalize">{{ field.replace('_', ' ') }}
            <span class="text-red-500" *ngIf="['name', 'type', 'contact_number', 'email', 'institution_code'].includes(field)"> *</span>
          </label>
          <input pInputText [formControlName]="field" class="w-full" />

          <!-- Error messages -->
          <small class="text-red-500" *ngIf="organizationForm.controls[field].touched && organizationForm.controls[field].errors?.required">
            {{ field.replace('_', ' ') }} is required.
          </small>
          <small class="text-red-500" *ngIf="organizationForm.controls[field].touched && organizationForm.controls[field].errors?.pattern">
            <ng-container *ngIf="field === 'contact_number'">Contact number must be 10 digits.</ng-container>
            <ng-container *ngIf="field === 'email'">Enter a valid email.</ng-container>
            <ng-container *ngIf="field === 'postal_code'">Enter a valid postal code (max 6 digits).</ng-container>
            <ng-container *ngIf="field === 'establishment_year'">Enter a valid year (4 digits).</ng-container>
          </small>
        </div>

      </div>  <div class="flex justify-start mt-4">
        <button pButton label="Save" icon="pi pi-check" (click)="saveOrganization()" [disabled]="organizationForm.invalid|| isSaving"  [loading]="isSaving" autoFocus></button>
      </div>
    </div>
  </form>

 
</p-dialog> 

<!-- Organization Table -->
<div class="p-4 overflow-auto h-[85vh]">
  <p-table [value]="organizations" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true" (onLazyLoad)="loadOrganizations($event)" [(selection)]="selectedOrganizations" [loading]="loading"     [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      
      <ng-template pTemplate="header">
          <tr>
            <th>Id</th>
              <th>Name</th>
              <th>Type</th>
              <th>Contact Number</th>
              <th>State</th>
              <th>Institution Code</th>
              <th>Action</th>
             </tr>
      </ng-template>

      <ng-template pTemplate="body" let-customer>
          <tr>
             <td>{{ customer.organization_id }}</td>
              <td>{{ customer.name || 'N/A' }}</td>
              <td>{{ customer.type || 'N/A' }}</td>
              <td>{{ customer.contact_number || 'N/A' }}</td>
              <td>{{ customer.state || 'N/A' }}</td>
              <td>{{ customer.institution_code || 'N/A' }}</td>
              <td>
                <button pButton type="button" icon="pi pi-ellipsis-v" 
                        class="p-button-text p-button-sm"
                        (click)="openMenu($event, customer)">
                </button>
              </td>
              
          </tr>
      </ng-template>

      <ng-template pTemplate="loading">
          <tr>
              <td colspan="6" class="text-center">
                  <p-progressSpinner></p-progressSpinner>
              </td>
          </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
          <tr>
              <td colspan="6" class="no-data">
                  <p>No records found</p>
              </td>
          </tr>
      </ng-template>
      
      
  </p-table>
  
  <p-menu #actionMenu [model]="actionItems" popup="true"></p-menu>

</div>
